import React from 'react';
import Box from '@mui/material/Box';
import { useUser } from './UserContext';
import WelcomeCard from './WelcomeCard';
import SectionCard from './SectionCard';

const About = () => {
  const { user } = useUser();

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      flex: 1, // Takes up remaining space
      paddingTop: '50px',
      paddingBottom: '50px',
    }}>
      <div style={{position: 'absolute', left: '0px', top: '0px', width:'100%', opacity: '10%', pointerEvents: 'none' }}>
        <img src='/mascot.png' alt=''/>
      </div>

      {!user && (
        <WelcomeCard />
      )}

      <SectionCard
        headline="Born from the Sea"
        text="A messy but workable version of Snapperish was first created to support the Pelagic Sailing Club's annual photo contest. A terribly difficult mechanism of emails and Google forms was previously being used, so a developer club member built a simple one-page app that could be configured using a JSON file stored on a server. The one page app was used on Pelagic for two contests, and Snapperish.com was tested by Pelagic for their 2025 contest."
        index={0}
      />

      <SectionCard
        headline="Built by Five Pack AI"
        text="Five Pack Creative's Innovation Lab took on the club photo contest idea to test how well AI can build an app. The site's React web app is about 90% coded by AI tools, and the back end, originally built in PHP / Apache / MySQL / S3, was rewritten in Cloudflare Workers / SQLite / R2 entirely by AI."
        index={1}
      />

      <SectionCard
        headline="Snapperish"
        text="Surprisingly, there isn't a photo contest app targeted to clubs. There are plenty of public photo contests but nothing that targets a limited time member-only contest."
        index={2}
      />

      <SectionCard
        headline="Our Team"
        text="The team right now is Matt @ Five Pack developing the front and back end with support from other Five Pack team members for testing, design, finance, and marketing. Matt is a sailor and former Pelagic Sailing Club member and uses a variety of AI tools to help build and maintain Snapperish."
        index={3}
      />
    </Box>
  );
};

export default About;